'use client';

import createTheme from './createTheme';
const defaultTheme = createTheme();
export default defaultTheme;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/styles/defaultTheme.js
// module id = 259
// module chunks = 22